import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import NavProduct from "./NavProduct";
import { mapStateToProps } from "../../redux/store";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";
const ShoppingBag = styled.div`
  display: ${({ cartToggle }) => (cartToggle ? "block" : "none")};
  padding: 2rem 1rem;
  position: absolute;
  z-index: 101;
  background-color: white;
  right: 0;
  top: 100%;
  width: 375px;
  max-width: 100%;
  max-height: 80vh;
  overflow-y: auto;
`;
const BagCount = styled.div`
  margin-bottom: 2.5rem;
  font-weight: 700;
  &::after {
    content: "${({ count }) => `${count} items`}";
    font-weight: 500;
  }
`;
const NavProducts = styled.div``;
const Total = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
`;
const TotalText = styled.div`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
`;
const TotalNumber = styled.div`
  font-weight: 700;
`;
const ShoppingActions = styled.div`
  display: flex;
  gap: 0.75rem;
  & > * {
    flex: 1;
  }
`;
const GoToCart = styled(Link)`
  padding: 1rem 2rem;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid black;
  background-color: transparent;
  cursor: pointer;
  text-align: center;
`;
const Checkout = styled.button`
  font-family: "Raleway", sans-serif;
  padding: 1rem 2rem;
  font-size: 14px;
  font-weight: 600;
  border: none;
  background-color: #5ece7b;
  color: white;
  background-color: ${({ quantity }) =>
    quantity ? "#5ece7b" : "rgba(94,206,123,0.5)"};
  cursor: ${({ quantity }) => (quantity ? "pointer" : "default")};
`;
class NavCart extends Component {
  render() {
    if (this.props && this.props.cartState && this.props.cartToggle) {
      const totalPrice = this.props.cartState.reduce((prev, product) => {
        const productPrice = product.productDetails.prices.find(
          (price) => price.currency.label === this.props.currencyState.label
        );
        return (prev += productPrice.amount * product.quantity);
      }, 0);

      return (
        <ShoppingBag cartToggle={this.props.cartToggle}>
          <BagCount count={this.props.totalProductsQuantity}>My Bag.</BagCount>
          <NavProducts>
            {this.props.cartState.map((product) => (
              <NavProduct product={product} key={uuidv4()} />
            ))}
          </NavProducts>
          <Total>
            <TotalText>Total</TotalText>
            <TotalNumber>
              {this.props.currencyState.symbol}
              {totalPrice.toFixed(2)}
            </TotalNumber>
          </Total>
          <ShoppingActions>
            <GoToCart to="/cart">VIEW BAG</GoToCart>
            <Checkout quantity={this.props.totalProductsQuantity}>
              CHECK OUT
            </Checkout>
          </ShoppingActions>
        </ShoppingBag>
      );
    }
  }
}

export default connect(mapStateToProps)(NavCart);
